interface FormButtonProps {
  children: string;
  icon?: boolean;
  type: 'submit' | 'reset' | 'button' | undefined;
  disabled?: boolean;
  className?: string;
  primary: boolean;
  widthStyling?: string;
}

export const FormButton = (props: FormButtonProps) => {
  const icon = () => {
    if (props.icon === true)
      return (
        <img
          key="img"
          src={`/buttonIcon${props.disabled ? 'Disabled' : 'Active'}.png`}
          className="inline-block w-5 pb-1 pl-3"
        />
      );
    return <span></span>;
  };

  const getControl = (className: string) => {
    return (
      <button className={`${className} cursor-pointer`} type={props.type}>
        {props.children}
        {icon()}
      </button>
    );
  };

  const disabledClassStyling = props.primary
    ? 'bg-secondary-deep-blue-80 pointer-events-none cursor-not-allowed text-secondary-deep-blue-55'
    : 'border-secondary-deep-blue-55 pointer-events-none cursor-not-allowed text-secondary-deep-blue-55 border-[1px]';
  const activeClassStyling = props.primary
    ? 'bg-interactive-coral hover:bg-solid-bold-green cursor-pointer text-solid-deep-blue'
    : 'border-interactive-coral text-interactive-coral border-[1px] hover:bg-interactive-bold-green-db-12';

  const widthStyling = props.widthStyling != undefined ? props.widthStyling : 'w-fit';

  const elementStyling = props.disabled ? disabledClassStyling : activeClassStyling;

  return getControl(
    `${props.className} ${elementStyling} inline-block ${widthStyling} font-bold pl-7 pr-7 pt-2 pb-2 text-center`
  );
};
